import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  noWidgets: "No widgets are switched on for this dashboard.",
  unableToLoad: "Unable to load dashboard data.",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    noWidgets: "Aucun widget n'est activé pour ce tableau de bord.",
    unableToLoad: "Impossible de charger les données du tableau de bord.",
  },
  es_ES: {
    noWidgets: "No hay widgets activados en este panel.",
    unableToLoad: "No se pudieron cargar los datos del panel.",
  },
  pt_BR: {
    noWidgets: "Nenhum widget está ativado neste painel.",
    unableToLoad: "Não foi possível carregar os dados do painel.",
  },
  de_DE: {
    noWidgets: "Für dieses Dashboard sind keine Widgets aktiviert.",
    unableToLoad: "Dashboard-Daten konnten nicht geladen werden.",
  },
  it_IT: {
    noWidgets: "Nessun widget è attivo per questa dashboard.",
    unableToLoad: "Impossibile caricare i dati della dashboard.",
  },
  ar: {
    noWidgets: "لا توجد أدوات مفعّلة في لوحة المعلومات هذه.",
    unableToLoad: "تعذّر تحميل بيانات لوحة المعلومات.",
  },
  ja_JP: {
    noWidgets: "このダッシュボードで有効なウィジェットはありません。",
    unableToLoad: "ダッシュボードのデータを読み込めません。",
  },
  hi_IN: {
    noWidgets: "इस डैशबोर्ड के लिए कोई विजेट चालू नहीं है।",
    unableToLoad: "डैशबोर्ड डेटा लोड नहीं हो सका।",
  },
  zh_CN: {
    noWidgets: "此仪表板未启用任何小组件。",
    unableToLoad: "无法加载仪表板数据。",
  },
  zh_TW: {
    noWidgets: "此儀表板未啟用任何小工具。",
    unableToLoad: "無法載入儀表板資料。",
  },
  nl_NL: {
    noWidgets: "Er zijn geen widgets ingeschakeld voor dit dashboard.",
    unableToLoad: "Kan dashboardgegevens niet laden.",
  },
  nb_NO: {
    noWidgets: "Ingen widgeter er slått på for dette dashbordet.",
    unableToLoad: "Kunne ikke laste dashborddata.",
  },
  sv_SE: {
    noWidgets: "Inga widgetar är aktiverade för den här dashboarden.",
    unableToLoad: "Det gick inte att läsa in dashboarddata.",
  },
  fi_FI: {
    noWidgets: "Tälle koontinäytölle ei ole otettu käyttöön widgetejä.",
    unableToLoad: "Koontinäytön tietoja ei voitu ladata.",
  },
  da_DK: {
    noWidgets: "Der er ingen widgets slået til for dette dashboard.",
    unableToLoad: "Kunne ikke indlæse dashboarddata.",
  },
  is_IS: {
    noWidgets: "Engar græjur eru virkar á þessu mælaborði.",
    unableToLoad: "Ekki tókst að hlaða gögnum mælaborðsins.",
  },
};
